import http from 'core/http.service';
import BaseService from 'services/BaseService';
import { Page } from 'models/page';
import { ProductDTO, ProductSearchDTO } from 'models/product';

class ProductService extends BaseService {
    /** 제품 목록 조회 (관리자) */
    public list(search: ProductSearchDTO): Promise<Page<ProductDTO>> {
        return super.request(http.get('/product', search));
    }

    /** 제품 상세 조회 */
    public get(id: number): Promise<ProductDTO> {
        return super.request(http.get(`/product/${id}`));
    }

    /** 제품 저장 (신규/수정 겸용) */
    public save(dto: ProductDTO): Promise<ProductDTO> {
        return super.request(http.post('/product', dto));
    }

    /** 제품 삭제 */
    public remove(id: number): Promise<void> {
        return super.request(http.delete(`/product/${id}`));
    }

    /** 제품 활성화/비활성화 토글 */
    public toggleActive(id: number): Promise<ProductDTO> {
        return super.request(http.put(`/product/${id}/toggle-active`, {}));
    }

    /** 활성 제품 목록 (자동완성용) */
    public getActiveProducts(keyword?: string): Promise<ProductDTO[]> {
        const params = keyword ? { keyword } : {};
        return super.request(http.get('/product/active', params));
    }
}

const productService = new ProductService();
export default productService;